import React from 'react';
import { Trophy } from 'lucide-react';
export function Results() {
  const results = [{
    amount: '$32.5 Million',
    caseType: 'Mesothelioma Verdict',
    details: 'For a former California shipyard worker exposed to asbestos-containing insulation.'
  }, {
    amount: '$18.2 Million',
    caseType: 'Asbestos Settlement',
    details: 'For a Los Angeles construction worker diagnosed with pleural mesothelioma.'
  }, {
    amount: '$12.4 Million',
    caseType: 'Wrongful Death',
    details: 'Awarded to the family of a US Navy veteran who served on ships docked in San Diego.'
  }, {
    amount: '$8.9 Million',
    caseType: 'Mesothelioma Settlement',
    details: 'For an auto mechanic exposed to asbestos in brake pads and clutches in Northern California.'
  }];
  return <section id="results" className="py-20 md:py-24 bg-slate-50 border-y border-slate-200" data-id="element-243" data-mp="273djuggfzcag">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-244" data-mp="1m3ayrott8lpi">
        <div className="text-center mb-14" data-id="element-245" data-mp="1m4vtbeg4k4nd">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-900 mb-4" data-id="element-246" data-mp="1r1m87yg70u77">
            Record-Breaking California Settlements
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-247" data-mp="1vzxlyk9lzoup">
            Our results speak for themselves. We have secured some of the
            largest mesothelioma verdicts and settlements in California history.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-248" data-mp="2a0i55hjfrmoq">
          {results.map((result, index) => <div key={index} className="bg-white rounded-xl p-8 shadow-sm border border-slate-100 hover:shadow-md transition-shadow relative overflow-hidden group" data-id="element-249" data-mp="2esrpmi1s7ujm" data-mpi={index}>
              <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-250" data-mp="2or7fkhp2oxrj">
                <Trophy className="w-16 h-16 text-brand-accent" data-id="element-251" data-mp="2ss11x6mva4ib" />
              </div>
              <div className="relative z-10" data-id="element-252" data-mp="tnj66ulaxgxk">
                <div className="text-3xl font-bold text-brand-900 mb-2" data-id="element-253" data-mp="onn26vcltpi0">
                  {result.amount}
                </div>
                <div className="text-sm font-bold text-brand-accent uppercase tracking-wider mb-4" data-id="element-254" data-mp="12fbd4vb4a7xe">
                  {result.caseType}
                </div>
                <p className="text-slate-600 text-sm leading-relaxed" data-id="element-255" data-mp="xm8kcpe5z2i9">
                  {result.details}
                </p>
              </div>
            </div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-256" data-mp="17dwbep6t6hj7">
          <p className="text-sm text-slate-500 italic" data-id="element-257" data-mp="1lefinu3g9jkb">
            *Past results do not guarantee, warrant, or predict future cases.
            Every case is unique.
          </p>
        </div>
      </div>
    </section>;
}